import { Capacitor } from '@capacitor/core';

/** Single source of truth for runtime-platform decisions. */
export const platform = {
  isNative: (): boolean => Capacitor.isNativePlatform(),
  isIOS: (): boolean => Capacitor.getPlatform() === 'ios',
  isAndroid: (): boolean => Capacitor.getPlatform() === 'android',
  isWeb: (): boolean => Capacitor.getPlatform() === 'web',
  /** Used when authoring user-agent strings or analytics dimensions. */
  name: (): 'ios' | 'android' | 'web' => Capacitor.getPlatform() as 'ios' | 'android' | 'web',
};

/** True if running under `capacitor://` origin — distinguishes native shell from web PWA. */
export function isCapacitorOrigin(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.protocol === 'capacitor:';
}
